import React, { lazy, Suspense } from 'react';
import { Container } from 'components/UI';
import { Icon, Title } from '@landing/ui';
import { useIsSsr } from 'utils/hooks';

import * as styles from './Intro.module.scss';

const Animation = lazy(() => import('components/UI/Animation'));

export default function Intro({ title, subtitle, date, time, location }) {
  const isSsr = useIsSsr();

  return (
    <Container className={styles.container} background="transparent">
      <div className={styles.layout}>
        <div className={styles.content}>
          <Title tag="h1" color="white">
            {title}
          </Title>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          <div className={styles.details}>
            <div className={styles.detailsItem}>
              <Icon name="calendar" className={styles.detailIcon} />
              <span>{date}</span>
            </div>
            <div className={styles.detailsItem}>
              <Icon name="clock" className={styles.detailIcon} />
              <span>{time}</span>
            </div>
            <div className={styles.detailsItem}>
              <Icon name="marker" className={styles.detailIcon} />
              <span>{location}</span>
            </div>
          </div>
        </div>
        {!isSsr && (
          <Suspense fallback={null}>
            <Animation preserveAspectRatio className={styles.animation} name="intro" />
          </Suspense>
        )}
      </div>
    </Container>
  );
}
